module.exports = __webpack_public_path__ + "bradavice_1_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/bradavice_1_after.jpg
// module id = 929
// module chunks = 0